import { CenterDto } from "./center-dto.model";

export class UserDto {
  public email: string;
  public name: string;
  public last_name: string;
  public is_marketing_allowed: boolean;
  public is_demo: boolean;
  public accepted_terms_version: number;
  public accepted_privacy_policy_version: number;
  public accepted_terms?: boolean;
  public accepted_privacy_policy?: boolean;
  public pending_legal_acceptances?: Array<{
    document_type: string;
    version: number;
  }>;
  public is_staff?: boolean;
  public center_admin?: boolean;
  public center: CenterDto;
  public password: string;
  public language?: string;
}
